import { Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import { UserInfo, UserQuota } from "types";

import {
  SET_USER_INFO,
  SET_USER_CONFIG,
  SET_USER_QUOTA,
  IS_LOADING,
} from "./constants";
import { State } from "redux/store";

import { axiosGet, composeApiURL } from "helpers/utility/axiosHelpers";
import { initPendo } from "helpers/utility/pendo";

import { User } from "types";
import axios from "helpers/axiosInstance";
import {
  isFeatureEnabled,
  transformFilterData,
} from "helpers/utility/utilities";
import { USAGE_REPORT } from "helpers/constants/filters";

const HOST_URL = process.env.REACT_APP_API_ENDPOINT!;

export const setUserInfo = (data: UserInfo) => {
  return { type: SET_USER_INFO, data };
};

export const setUserQuota = (data: UserQuota | null) => {
  return { type: SET_USER_QUOTA, data };
};

export const setIsLoading = (data: boolean) => {
  return { type: IS_LOADING, data };
};

export const fetchUserInfo = (
  user: User,
): ThunkAction<void, State, unknown, any> => {
  return async (dispatch: Dispatch) => {
    try {
      const url = composeApiURL(process.env.REACT_APP_API_ENDPOINT!, `/user`);
      let response = await axiosGet(url, user);
      let userInfo: UserInfo = {
        userAvatar: response.data.avatar_uri,
        isInternalUser: response.data.is_internal_user,
        email: response.data.email,
        userId: response.data.user_id,
        identityProvider: response.data.identity_provider,
        name: response.data.name,
        username: response.data.username,
      };
      dispatch(setUserInfo(userInfo));
      initPendo(user, userInfo.email);
    } catch (error) {
      console.log(error);
    }
  };
};

export const setUserConfig = (data: any) => {
  return { type: SET_USER_CONFIG, data };
};

export const fetchUserConfig = (): ThunkAction<void, State, unknown, any> => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(setIsLoading(true));
      const url = composeApiURL(
        process.env.REACT_APP_API_ENDPOINT!,
        `/user_config`,
      );
      const response = await axios.get(url);

      const transformedData = transformFilterData(response.data?.features);
      dispatch(setUserConfig(transformedData));

      //get UsageInfo if Feature-Gating allows
      const isUsageReportEnabled = isFeatureEnabled(
        transformedData,
        USAGE_REPORT,
      );

      if (isUsageReportEnabled) {
        dispatch(checkUserQuota() as any);
      }
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(setIsLoading(false));
    }
  };
};

export const checkUserQuota = (): ThunkAction<void, State, unknown, any> => {
  return async (dispatch: Dispatch) => {
    try {
      const url = composeApiURL(HOST_URL, `/usage_report`);
      const { data: responseData } = await axios.get(url);

      if (responseData) {
        const quota: UserQuota = {
          accountType: responseData.account,
          totalQuota: responseData.image_quota,
          usedQuota: responseData.image_usage,
          availableQuota: responseData.remaining_quota,
          email: responseData.email,
        };

        dispatch(setUserQuota(quota));
      } else {
        dispatch(setUserQuota(null));
      }
    } catch (error: any) {
      console.log(error);
    }
  };
};
